import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "toggleButton"]

  toggle() {
    this.formTarget.classList.toggle("hidden")

    if (this.formTarget.classList.contains("hidden")) {
      this.toggleButtonTarget.classList.remove("hidden")
    } else {
      this.toggleButtonTarget.classList.add("hidden")
      // Focus the first input
      const firstInput = this.formTarget.querySelector("input[type='text']")
      if (firstInput) {
        firstInput.focus()
      }
    }
  }
}
